import {View} from "@lernetz/ts-lib";
import template from "./modal.component.html";

export class ModalView extends View {
    constructor() {
        super({template, data: new ModalViewController()})
    }

}
class ModalViewController {
    info: any;
    hidden: boolean;
    init() {
        this.hidden = !!window.localStorage.getItem("bannerHidden");
    }
    hide() {
        this.hidden = true;
        window.localStorage.setItem("bannerHidden", "true");
    }
    show() {
        this.hidden = false;
        window.localStorage.removeItem("bannerHidden");
    }
}
